export default __webpack_public_path__ + "static/why_cash_transit_3.png";